/* src/app/price-list/pages/price-list-edit/price-list-edit.component.scss */
/*# sourceMappingURL=price-list-edit.component.css.map */
